import React from 'react';
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from '../../../../entidades';
import { HomeCard } from '../../HomeCard/HomeCard';
import { Alert, Button, Row, Col, Badge } from '@intech/web-ui';

interface IProps {
  plano: PlanoVinculadoEntidade;
  tempoPlano: string;
  SRC: number;
  referencia: string;
}

export const Header: React.FC<IProps> = ({
  plano,
  tempoPlano,
  SRC,
  referencia
}) => {

  function ToMoney(Valor: number) {
    return (
      "R$ " + Valor.toLocaleString('pt-br', { minimumFractionDigits: 2 })
    );
  }

  return (
    <>
      <Row>
        <Col>
          <HomeCard titulo={"Plano"}>
            {plano.DS_PLANO}<br />
            <small>
              <span style={{ "fontWeight": "normal" }}>
                {`CNPB: ${plano.COD_CNPB}`}
              </span>
            </small>
          </HomeCard>
        </Col>

        <Col>
          <HomeCard titulo={"Situação no Plano"}>
            {plano.DS_SIT_PLANO}
          </HomeCard>
        </Col>
      </Row>

      <Row>
        <Col>
          <HomeCard titulo={"Data de Inscrição"}>
            {plano.DT_INSC_PLANO}
          </HomeCard>
        </Col>

        <Col>
          <HomeCard titulo={"Tempo de Plano"}>
            {tempoPlano}
          </HomeCard>
        </Col>
      </Row>

      <Row>
        {plano.CD_PLANO !== "0001" &&
          <Col>
            <HomeCard titulo={"Regime de Tributação"}>
              {plano.TIPO_IRRF === "2" ? "Regressivo" : "Progressivo"}
            </HomeCard>
          </Col>
        }

        <Col>
          <HomeCard titulo={"Salário Real de Contribuição"} label={`em ${referencia}`}>
            {ToMoney(SRC)}
          </HomeCard>
        </Col>
      </Row>
    </>
  );
}